@if (tableData && ccrSummary && translations) {
<mat-card appearance="outlined">
  <mat-card-title class="edit-screen-card-title">
    Променливи
  </mat-card-title>
  <mat-card-content>
  <div flex class="variables-container" layout="row" layout-wrap  layout-align="start center">
    @for (column of columns ; track column) {
      <div flex="25">
        <mat-card class="summary-prop" appearance="outlined">
          <div class="variable-container" layout="row" layout-align="space-between center" flex>
            <span>{{column.label}}</span>
            <span>{{ccrSummary[column.name]}}</span>
          </div>
        </mat-card>
      </div>
    }
  </div>
  </mat-card-content>
</mat-card>
}